var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(0 -0.001)",
    fill: "#fa5a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_388",
    "data-name": "Union 388",
    d: "M19901,1624v-.9a4.512,4.512,0,0,1,2.232-3.887,2.7,2.7,0,1,1,4.5,0,4.517,4.517,0,0,1,2.27,3.887v.9Zm10.412-1.935a7.2,7.2,0,1,0-8.611-7.064h-1.8a9.108,9.108,0,1,1,10.764,8.864Zm-2.312-6.695V1609.6h1.8v5.03l2.438,2.43-1.279,1.278Z",
    transform: "translate(-19890.113 -1594.999)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.a6a4557de76dbb9a8f04faae59fe727c.svg";
export { ForwardRef as ReactComponent };